"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useAssessments } from "@/hooks/useAssessments";
import { apiFetch } from "@/lib/api";
import { SidebarAssessmentList } from "@/components/layout/SidebarAssessmentList";
import { SidebarFooter } from "@/components/layout/SidebarFooter";

export function AppSidebar() {
  const router = useRouter();
  const { assessments, isLoading, refresh } = useAssessments();

  const handleNewAssessment = async () => {
    try {
      const response = await apiFetch("/chat/start", {
        method: "POST",
      });
      const data = await response.json();
      if (data.sessionId) {
        await refresh(); // Update the list
        router.push(`/assessments/${data.sessionId}`);
      }
    } catch (error) {
      console.error("Failed to start new assessment:", error);
    }
  };

  return (
    <aside className="flex w-[min(100%,17rem)] h-svh shrink-0 flex-col border-r border-(--border-subtle) bg-(--bg-elevated) shadow-(--shadow-card) lg:w-72 transition-all">
      <div className="border-b border-(--border-subtle) px-4 py-5">
        <Link href="/" className="group flex items-start gap-3">
          <span
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-(--brand-peach) text-sm font-bold text-(--logo-font) ring-1 ring-(--border-strong)"
            aria-hidden
          >
            F
          </span>
          <div className="min-w-0 flex-1 leading-tight">
            <span className="block text-base font-bold tracking-tight text-foreground">
              FinOps AI
            </span>
            <span className="mt-0.5 block text-xs text-(--text-secondary)">
              Assessment workspace
            </span>
          </div>
        </Link>
        <button
          onClick={handleNewAssessment}
          className="focus-ring mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-brand-gradient px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-95"
        >
          <svg
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 4v16m8-8H4"
            />
          </svg>
          New Assessment
        </button>
      </div>

      <nav
        className="flex min-h-0 flex-1 flex-col gap-1 overflow-hidden p-3"
        aria-label="Assessments"
      >
        <SidebarAssessmentList 
          assessments={assessments.map(a => ({
            id: a.id,
            title: a.title,
            status: a.current_stage,
            updatedAt: a.updated_at
          }))} 
        />
        {isLoading && (
          <div className="px-4 py-2 text-[10px] text-(--text-tertiary) animate-pulse">
            Syncing workspace...
          </div>
        )}
      </nav>

      <SidebarFooter />
    </aside>
  );
}
